import { Select, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { OrganizationMultiSelect } from 'components/selects/OrganizationSelect';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import { IAutomation } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import { useMemo } from 'react';

/**
 * Shared optional automation-level condition fields.
 */
export default function AutomationConditionsFields({ form }: { form: UseFormReturnType<IAutomation> }) {
  const { allInputs } = useFormInputs();

  const truthyRevisionInputData = useMemo(
    () =>
      allInputs
        .filter(
          ({ context, spec: { type } }) => context === 'revision' && (type === 'checkbox' || type === 'comparator')
        )
        .map((input) => ({ value: input.spec.name, label: input.spec.label })),
    [allInputs]
  );

  return (
    <Stack spacing={12}>
      <Select
        data={truthyRevisionInputData}
        label="Spustiť iba ak platí"
        placeholder="Bez obmedzenia"
        clearable
        searchable
        size="sm"
        {...form.getInputProps('runIfTrue')}
      />
      <OrganizationMultiSelect
        label="Spustiť iba pre zákaznícke organizácie"
        placeholder="Všetky organizácie"
        searchable
        clearable
        size="sm"
        value={(form.values.customerOrganizationIds ?? []).map(String)}
        onChange={(values) => form.setFieldValue('customerOrganizationIds', values.map(Number))}
        error={form.errors.customerOrganizationIds}
      />
    </Stack>
  );
}
